import { DefaultRootState } from 'react-redux';

export const isOpen = (state: DefaultRootState) => {
  const { invitation } = state;
  if (!invitation.current || !invitation.current.id || !invitation.data?.[invitation.current.id]) {
    return false;
  }
  return invitation.current.isOpen;
};

export const isLoading = (name: 'attending' | 'notAttending' | 'info' | 'note' | string) => (state: DefaultRootState) => {
  const { invitation } = state;
  return Boolean(invitation.meta.isLoading[name]);
};

export const isLoadingAny = (state: DefaultRootState) => {
  const { invitation } = state;
  return Object.keys(invitation.meta.isLoading).length > 0;
};

export const getEvent = (state: DefaultRootState) => {
  const { invitation } = state;
  if (!invitation.current || !invitation.current.id || !invitation.data?.[invitation.current.id]) {
    return null;
  }
  return invitation.data?.[invitation.current.id] || null;
};

export const getRSVP = (state: DefaultRootState) => {
  return state.invitation.current?.rsvp || null;
};

export const getStep = (state: DefaultRootState) => {
  return state.invitation.current?.step || null;
};
